// 获取 滚动条 宽度
function getScrollBarWidth() {
  const rootStyles = getComputedStyle(document.documentElement)
  return rootStyles.getPropertyValue('--scroll-bar-width')
}

function lock() {
  document.body.style.overflow = 'hidden'
  if (window.innerWidth > 1024) {
    document.body.style.paddingRight = getScrollBarWidth()
  }
}

function unlock() {
  document.body.style.overflow = ''
  if (window.innerWidth > 1024) {
    document.body.style.paddingRight = '0px'
  }
}


export const lockBodyScroll = {
  mounted(_, binding) {
    if (binding.value) {
      lock()
    }
  },
  updated(_, binding) {
    if (binding.value !== binding.oldValue) {
      binding.value ? lock() : unlock()
    }
  },
  unmounted() {
    unlock()
  }
}
